import DialogoServico from './DialogoServico'
const dialogoServico = new DialogoServico()

class MensagemServico {
  cadastroInvalido(validacao) {
    const erros = this.obterErrosValidacao(validacao)

    if (!erros.length) {
      this.alerta('Cadastro inválido.')
      return
    }

    const itensHtml = erros
      .map((erro) => `<li>${this.escapeHtml(erro)}</li>`)
      .join('')

    this.alerta(
      {
        content: `<ul>${itensHtml}</ul>`,
        html: true,
      },
      'Erros de validação'
    )
  }

  obterErrosValidacao(validacao) {
    if (!validacao) {
      return []
    }

    const erros = Array.isArray(validacao.$errors) ? validacao.$errors : []
    const mensagens = erros
      .map((erro) => this.formatarErro(erro))
      .filter((mensagem) => !!mensagem)

    return [...new Set(mensagens)]
  }

  formatarErro(erro = {}) {
    const caminho = erro.$propertyPath || erro.$property || 'campo'
    const nomeCampo = this.formatarCaminho(caminho)
    const regra = erro.$validator || 'invalido'
    const params = erro.$params || {}

    return `${nomeCampo}: ${this.descreverRegra(regra, params)}`
  }

  formatarCaminho(caminho = '') {
    const partesFormatadas = caminho
      .toString()
      .split('.')
      .filter((parte) => parte && parte !== '$each')
      .map((parte) => {
        if (/^\d+$/.test(parte)) {
          return `item ${Number(parte) + 1}`
        }

        const texto = parte
          .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
          .replace(/[_-]+/g, ' ')
          .trim()
        return texto.charAt(0).toUpperCase() + texto.slice(1)
      })

    if (partesFormatadas.length > 1) {
      partesFormatadas.shift()
    }

    return partesFormatadas.join(' > ')
  }

  descreverRegra(regra, params = {}) {
    const traducoes = {
      required: 'é obrigatório.',
      requiredIf: 'é obrigatório.',
      minLength: `deve ter no mínimo ${params.min} caracteres.`,
      maxLength: `deve ter no máximo ${params.max} caracteres.`,
      minValue: `deve ser maior ou igual a ${params.min}.`,
      maxValue: `deve ser menor ou igual a ${params.max}.`,
      email: 'deve ser um e-mail válido.',
      numeric: 'deve conter apenas números.',
      integer: 'deve ser um número inteiro.',
      decimal: 'deve ser um número decimal válido.',
      sameAs: 'não confere com o valor esperado.',
      url: 'deve ser uma URL válida.',
      alpha: 'deve conter apenas letras.',
      alphaNum: 'deve conter apenas letras e números.',
    }

    if (traducoes[regra]) {
      return traducoes[regra]
    }

    return `é inválido (${regra}).`
  }

  escapeHtml(texto = '') {
    return texto
      .toString()
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;')
  }

  alerta(conteudo, titulo) {
    if (typeof conteudo === 'undefined') {
      return
    }

    const payload =
      conteudo && typeof conteudo === 'object'
        ? conteudo
        : { content: String(conteudo) }

    const tituloResolvido =
      typeof titulo === 'undefined' ? payload.title || '' : titulo

    dialogoServico.alerta({
      ...payload,
      title: tituloResolvido,
    })
  }
}

export default MensagemServico
